import React from 'react';

export interface MaterialButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

export enum UserFlags {
  STAFF = 1 << 0,
  VERIFIED = 1 << 1,
  PARTNER = 1 << 2,
  EARLY_ACCESS = 1 << 3,
}

export const FLAG_CONFIG: Record<UserFlags, { labelKey: string; imageSrc: string }> = {
  [UserFlags.VERIFIED]: {
    labelKey: 'BADGE_VERIFIED',
    imageSrc: './badgeVerified.svg',
  },
  [UserFlags.STAFF]: {
    labelKey: 'BADGE_STAFF',
    imageSrc: './badgeStaff.svg',
  },
  [UserFlags.PARTNER]: {
    labelKey: 'BADGE_PARTNER',
    imageSrc: './badgePartner.svg',
  },
  [UserFlags.EARLY_ACCESS]: {
    labelKey: 'BADGE_EARLY',
    imageSrc: './badgeEearlyAccess.svg',
  },
};


export function stringToArrayBuffer(str: string): ArrayBuffer {
  return new TextEncoder().encode(str).buffer;
}

// ArrayBuffer → string
export function arrayBufferToString(buffer: ArrayBuffer): string {
  return new TextDecoder().decode(new Uint8Array(buffer));
}

export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  const chunkSize = 0x8000; // dla dużych buforów (unikamy stack overflow)

  for (let i = 0; i < bytes.length; i += chunkSize) {
    const chunk = bytes.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk as unknown as number[]);
  }

  return btoa(binary);
}

